import React from "react"
import { concatStrings } from "../utilities"
import DfbIcon from "../ui-kit/dfb_icon"
import DfbParagraph from "../ui-kit/dfb_paragraph"

const CIconButtonLink = ({href, add_class}) => {
  return (
    <a
      className={concatStrings("c-IconButtonLink", add_class)}
      href={href}
    >
      <DfbIcon icon_type="add" add_class="c-IconButtonLink-icon" />
      <DfbParagraph
        text="Kategorien abonnieren"
        add_class="c-IconButtonLink-label"
      />
    </a>
  )
}

export default CIconButtonLink
